var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWithdrawal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4335",
    "data-name": "Group 4335",
    transform: "translate(5666 8689)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1143",
    "data-name": "Rectangle 1143",
    width: 22,
    height: 22,
    transform: "translate(-5666 -8689)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "give-money",
    transform: "translate(-5666 -8709.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_5_58_",
    transform: "translate(0 22.508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4334",
    "data-name": "Group 4334",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4332",
    "data-name": "Group 4332",
    transform: "translate(8.37 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_17",
    "data-name": "Subtraction 17",
    d: "M5.823,11.51A5.8,5.8,0,0,1,0,5.756a5.822,5.822,0,0,1,11.644,0A5.583,5.583,0,0,1,9.938,9.823,5.988,5.988,0,0,1,5.823,11.51ZM4.658,7.093a.231.231,0,0,0-.219.153l-.114.305a.2.2,0,0,0,.1.248,3.9,3.9,0,0,0,.959.264h.006s.043.013.043.047v.461a.244.244,0,0,0,.25.237h.221a.242.242,0,0,0,.247-.237V8.086a.043.043,0,0,1,.039-.048A1.335,1.335,0,0,0,7.333,6.732c0-.656-.37-1.081-1.235-1.419-.657-.263-.847-.421-.847-.7,0-.228.174-.493.666-.493a1.858,1.858,0,0,1,.772.171.258.258,0,0,0,.114.028.231.231,0,0,0,.215-.145l.121-.3a.186.186,0,0,0-.1-.24,3.909,3.909,0,0,0-.776-.2l-.019,0c-.015,0-.04-.011-.04-.042l0-.44A.244.244,0,0,0,5.95,2.7H5.735a.243.243,0,0,0-.248.237V3.4c0,.017-.009.042-.053.054A1.273,1.273,0,0,0,4.36,4.7c0,.751.63,1.091,1.312,1.346.542.212.764.427.764.74,0,.341-.314.58-.764.58a2.634,2.634,0,0,1-.906-.243A.231.231,0,0,0,4.658,7.093Z",
    transform: "translate(0)",
    fill: "#63666f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4333",
    "data-name": "Group 4333",
    transform: "translate(0 12.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7444",
    "data-name": "Path 7444",
    d: "M112.294,221.359a14.929,14.929,0,0,1-4.638,1.563c-1.511.234-4.353-.331-4.353-1,0-.253,2.493.623,4,.225,1.156-.3.992-1.374.363-1.515s-4.288-1.467-5.853-1.512a27.357,27.357,0,0,0-3.437.4c-.3.049-.491.043-.51.328-.088,1.326-.26,4.038-.354,5.454,0,.03.04.432.376.149a1.755,1.755,0,0,1,1.361-.547c.749.168,7.224,1.34,8.117,1.135a22.62,22.62,0,0,0,5.589-3.071C114.03,221.946,113.194,220.868,112.294,221.359Z",
    transform: "translate(-91.461 -219.121)",
    fill: "#63666f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7445",
    "data-name": "Path 7445",
    d: "M4.618,222.2l-3.392-.165a.61.61,0,0,0-.595.433l-.617,5.535a.366.366,0,0,0,.358.475h3.76a.5.5,0,0,0,.513-.452l.413-5.333A.459.459,0,0,0,4.618,222.2Zm-2,5.545a.927.927,0,1,1,.938-.927A.933.933,0,0,1,2.621,227.747Z",
    transform: "translate(0 -221.858)",
    fill: "#63666f"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawal);
export default __webpack_public_path__ + "static/media/withdrawal.3a2fcb238ae59a4b518b5792556026be.svg";
export { ForwardRef as ReactComponent };